import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ChromeIcon } from 'lucide-react';
interface CanvaStyleAuthProps {
  mode: 'signin' | 'signup';
  onSubmit: (data: any) => void;
}
export function CanvaStyleAuth({
  mode,
  onSubmit
}: CanvaStyleAuthProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showEmailForm, setShowEmailForm] = useState(false);
  const handleSocialLogin = (provider: string) => {
    console.log(`Login with ${provider}`);
    onSubmit({
      provider
    });
  };
  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      email,
      password
    });
  };
  return <div className="w-full min-h-screen flex" data-id="element-363">
      {/* Left Side - Product Wall Background */}
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden bg-gray-900" data-id="element-364">
        <div className="absolute inset-0 grid grid-cols-4 gap-4 p-8 opacity-60" data-id="element-365">
          {Array.from({
          length: 32
        }).map((_, i) => <div key={i} className="aspect-[3/4] bg-gradient-to-br from-red-500 via-purple-500 to-blue-500 rounded-lg" style={{
          backgroundImage: `linear-gradient(${Math.random() * 360}deg, ${['#EF4444', '#8B5CF6', '#3B82F6', '#10B981', '#F59E0B'][Math.floor(Math.random() * 5)]}, ${['#DC2626', '#7C3AED', '#2563EB', '#059669', '#D97706'][Math.floor(Math.random() * 5)]})`
        }} data-id="element-366" />)}
        </div>
        <div className="absolute inset-0 bg-gradient-to-br from-black/50 to-black/30 backdrop-blur-sm" data-id="element-367" />
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-368">
          <div className="text-center text-white px-8" data-id="element-369">
            <h1 className="text-5xl font-bold mb-4" data-id="element-370">ZoomInfo GTM</h1>
            <p className="text-xl text-white/80" data-id="element-371">
              AI-powered platform for modern revenue teams
            </p>
          </div>
        </div>
      </div>
      {/* Right Side - Auth Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white" data-id="element-372">
        <div className="w-full max-w-md" data-id="element-373">
          {/* Logo */}
          <div className="flex items-center gap-3 mb-8" data-id="element-374">
            <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center text-white font-bold text-xl" data-id="element-375">
              Z
            </div>
            <div data-id="element-376">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-377">ZoomInfo</h2>
              <p className="text-sm text-gray-600" data-id="element-378">GTM Platform</p>
            </div>
          </div>
          {!showEmailForm ? <>
              {/* Welcome Text */}
              <div className="mb-8" data-id="element-379">
                <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-380">
                  {mode === 'signin' ? 'Welcome back' : 'Welcome to ZoomInfo GTM'}
                </h1>
                <p className="text-gray-600" data-id="element-381">
                  {mode === 'signin' ? 'Sign in to access your GTM workspace' : 'Create your account to get started with AI-powered GTM'}
                </p>
              </div>
              {/* Social Login Buttons */}
              <div className="space-y-3 mb-6" data-id="element-382">
                <button onClick={() => handleSocialLogin('google')} className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-383">
                  <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-384">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-385" />
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-386" />
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-387" />
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-388" />
                  </svg>
                  <span className="text-gray-700 font-medium" data-id="element-389">
                    Continue with Google
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('microsoft')} className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-390">
                  <svg className="w-5 h-5" viewBox="0 0 23 23" data-id="element-391">
                    <path fill="#f3f3f3" d="M0 0h23v23H0z" data-id="element-392" />
                    <path fill="#f35325" d="M1 1h10v10H1z" data-id="element-393" />
                    <path fill="#81bc06" d="M12 1h10v10H12z" data-id="element-394" />
                    <path fill="#05a6f0" d="M1 12h10v10H1z" data-id="element-395" />
                    <path fill="#ffba08" d="M12 12h10v10H12z" data-id="element-396" />
                  </svg>
                  <span className="text-gray-700 font-medium" data-id="element-397">
                    Continue with Microsoft
                  </span>
                </button>
                <button onClick={() => setShowEmailForm(true)} className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-398">
                  <MailIcon className="w-5 h-5 text-gray-600" data-id="element-399" />
                  <span className="text-gray-700 font-medium" data-id="element-400">
                    Continue with email
                  </span>
                </button>
              </div>
              {/* Divider */}
              <div className="relative my-6" data-id="element-401">
                <div className="absolute inset-0 flex items-center" data-id="element-402">
                  <div className="w-full border-t border-gray-300" data-id="element-403" />
                </div>
                <div className="relative flex justify-center text-sm" data-id="element-404">
                  <span className="px-2 bg-white text-gray-500" data-id="element-405">or</span>
                </div>
              </div>
              {/* Alternative Actions */}
              <div className="text-center" data-id="element-406">
                <button className="text-gray-700 hover:text-gray-900 font-medium text-sm" data-id="element-407">
                  Continue another way
                </button>
              </div>
            </> : <>
              {/* Email Form */}
              <div className="mb-8" data-id="element-408">
                <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-409">
                  {mode === 'signin' ? 'Sign in with email' : 'Create your account'}
                </h1>
                <p className="text-gray-600" data-id="element-410">
                  Enter your email and password to continue
                </p>
              </div>
              <form onSubmit={handleEmailSubmit} className="space-y-4" data-id="element-411">
                <div data-id="element-412">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-413">
                    Email
                  </label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="you@example.com" required data-id="element-414" />
                </div>
                <div data-id="element-415">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-416">
                    Password
                  </label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="••••••••" required data-id="element-417" />
                </div>
                {mode === 'signin' && <div className="flex items-center justify-between" data-id="element-418">
                    <label className="flex items-center" data-id="element-419">
                      <input type="checkbox" className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500" data-id="element-420" />
                      <span className="ml-2 text-sm text-gray-700" data-id="element-421">
                        Remember me
                      </span>
                    </label>
                    <button type="button" className="text-sm text-red-600 hover:text-red-700 font-medium" data-id="element-422">
                      Forgot password?
                    </button>
                  </div>}
                <button type="submit" className="w-full px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium transition-colors" data-id="element-423">
                  {mode === 'signin' ? 'Sign in' : 'Create account'}
                </button>
                <button type="button" onClick={() => setShowEmailForm(false)} className="w-full px-4 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors" data-id="element-424">
                  Back to login options
                </button>
              </form>
            </>}
          {/* Footer Links */}
          <div className="mt-8 text-center text-sm text-gray-600" data-id="element-425">
            {mode === 'signin' ? <p data-id="element-426">
                Don't have an account?{' '}
                <Link to="/signup" className="text-red-600 hover:text-red-700 font-medium" data-id="element-427">
                  Sign up
                </Link>
              </p> : <p data-id="element-428">
                Already have an account?{' '}
                <Link to="/login" className="text-red-600 hover:text-red-700 font-medium" data-id="element-429">
                  Sign in
                </Link>
              </p>}
          </div>
          {/* Terms */}
          <div className="mt-6 text-center text-xs text-gray-500" data-id="element-430">
            By continuing, you agree to our{' '}
            <a href="#" className="text-gray-700 hover:underline" data-id="element-431">
              Terms of Use
            </a>
            . Read our{' '}
            <a href="#" className="text-gray-700 hover:underline" data-id="element-432">
              Privacy Policy
            </a>
            .
          </div>
        </div>
      </div>
    </div>;
}